import { Typography } from '@mui/material'
import { stripMarkdownFormatting } from '@/utils/stripMarkdownFormatting'

const Blockquote = ({ children }) => {
  const content = stripMarkdownFormatting(typeof children === 'string' ? children : String(children ?? ''))
  if (!content.trim()) return null

  return (
    <Typography
      component="p"
      variant="body2"
      sx={{
        m: 0,
        my: '8px',
        color: 'text.primary',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        lineHeight: 1.6,
        whiteSpace: 'pre-wrap',
      }}
    >
      {content}
    </Typography>
  )
}

export default Blockquote
